import axios from "axios";
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";

const AdminTempList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGuests = async () => {
      try {
        const { data } = await axios.get("http://localhost:4001/api/v1/gettempguest");
        setGuests(data.guest);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch data");
        setLoading(false);
      }
    };
    fetchGuests();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredGuests = guests.filter((guest) =>
    guest.Company?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDownload = () => {
    const ws = XLSX.utils.json_to_sheet(
      filteredGuests.map((guest) => ({
        CompanyName: guest.Company || "N/A",
        Event: guest.Event || "N/A",
        Peoples: guest.Peoples || "N/A",
        Guests: guest.guest.map((g) => g.Name).join(", ") || "N/A",
        Documents: guest.guest.map((g) => g.document?.url || "N/A").join(", ")
      }))
    );

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Temporary Guests");
    XLSX.writeFile(wb, "TemporaryGuestList.xlsx");
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
        <input
          type="text"
          placeholder="Search by company name..."
          value={searchTerm}
          onChange={handleSearchChange}
          style={{ padding: "10px", width: "calc(100% - 120px)", boxSizing: "border-box", borderRadius: "13px" }}
        />
        <button
          onClick={handleDownload}
          style={{ padding: "10px 20px", borderRadius: "13px", border: "none", backgroundColor: "#4CAF50", color: "white", cursor: "pointer" }}
        >
          Download
        </button>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "2px solid #ddd", padding: "8px" }}>Sno</th>
            <th style={{ border: "2px solid #ddd", padding: "8px" }}>Company Name</th>
            <th style={{ border: "2px solid #ddd", padding: "8px" }}>Event</th>
            <th style={{ border: "2px solid #ddd", padding: "8px" }}>Peoples</th>
            <th style={{ border: "2px solid #ddd", padding: "8px" }}>Guests</th>
            <th style={{ border: "2px solid #ddd", padding: "8px" }}>Documents</th>
          </tr>
        </thead>
        <tbody>
          {filteredGuests.map((guest, index) => (
            <tr key={guest._id}>
              <td style={{ border: "2px solid #ddd", padding: "8px" }}>{index + 1}</td>
              <td style={{ border: "2px solid #ddd", padding: "8px" }}>{guest.Company || "N/A"}</td>
              <td style={{ border: "2px solid #ddd", padding: "8px" }}>{guest.Event || "N/A"}</td>
              <td style={{ border: "2px solid #ddd", padding: "8px" }}>{guest.Peoples || "N/A"}</td>
              <td style={{ border: "2px solid #ddd", padding: "8px" }}>{guest.guest.map((g) => g.Name).join(", ") || "N/A"}</td>
              <td style={{ border: "2px solid #ddd", padding: "8px" }}>
                {guest.guest.map((g, docIndex) =>
                  g.document?.url ? (
                    <div key={docIndex}>
                      <Link to={g.document.url} target="_blank" rel="noopener noreferrer">
                        Document {docIndex + 1}
                      </Link>
                    </div>
                  ) : (
                    "N/A"
                  )
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminTempList;